// extracted by mini-css-extract-plugin
export default {"wrapper":"Textarea_wrapper__5nXzP","textarea":"Textarea_textarea__hbVHD"};